import { FontSource } from '@wix/ambassador-emails-email-marketing-v1-font/types';
import { toTitleCaseWithoutQuotes, withQuotesRemoved } from './formatFontDisplayName';
const FIRST_COMMA = /,(.*)/s;
import { resolveFontsFromMjml } from './resolveFontsFromMjml';
export const getFontsFromMjml = _ref => {
  let {
    mjml,
    extendedList,
    customFonts
  } = _ref;
  const extendedListByLoweCasedName = getFontsByLowerCasedName(extendedList);
  const customFontsByLowercasedName = getFontsByLowerCasedName(customFonts);
  const mjmlFonts = resolveFontsFromMjml(mjml);
  const uniqueMjmlFonts = [...new Map(mjmlFonts.map(font => [font.split(',')[0].trim(), font])).values()];
  const extendedListFontsSet = new Set();
  const mjmlFontsOptions = uniqueMjmlFonts.map(font => {
    const [name, fallback] = font.split(FIRST_COMMA);
    const lowerCasedName = withQuotesRemoved(name.trim().toLowerCase());
    if (extendedListByLoweCasedName != null && extendedListByLoweCasedName[lowerCasedName]) {
      extendedListFontsSet.add(lowerCasedName);
      return {
        ...extendedListByLoweCasedName[lowerCasedName],
        fallback: fallback == null ? void 0 : fallback.trim()
      };
    }
    const isCustomFont = Boolean(customFontsByLowercasedName == null ? void 0 : customFontsByLowercasedName[lowerCasedName]);
    return {
      fontSource: isCustomFont ? FontSource.CUSTOM_FONT : FontSource.WEBFONTS_WEBFONT,
      name: isCustomFont ? customFontsByLowercasedName[lowerCasedName].name : toTitleCaseWithoutQuotes(name.trim()),
      fallback: fallback == null ? void 0 : fallback.trim(),
      downloadUrl: isCustomFont ? customFontsByLowercasedName[lowerCasedName].downloadUrl : undefined
    };
  });
  const predefinedFontsOptions = Object.values(extendedList || {}).filter(font => {
    var _font$name;
    return !extendedListFontsSet.has((_font$name = font.name) == null ? void 0 : _font$name.toLowerCase());
  });
  return [...mjmlFontsOptions, ...predefinedFontsOptions];
};
const getFontsByLowerCasedName = fontFamily => (fontFamily == null ? void 0 : fontFamily.reduce((acc, font) => {
  if (font.name) {
    acc[withQuotesRemoved(font.name.toLowerCase())] = font;
  }
  return acc;
}, {})) || {};
//# sourceMappingURL=getFontsFromMjml.js.map